import { RouteRecordRaw } from 'vue-router';
import { ROUTE_NAME } from '@constants';
import myPage from '@infra/router/module/my-page';
import desktopClubIntroduction from '@infra/router/module/club-introduction';
import mobileClubIntroduction from '@infra/router/module/club-introduction.mobile.ts';
import courseIntroduction from '@infra/router/module/course-introduction';
import reservation from '@infra/router/module/reservation';
import facility from '@infra/router/module/facility';
import desktopUseInformation from '@infra/router/module/use-information';
import mobileUseInformation from '@infra/router/module/use-information.mobile.ts';
import desktopCommunity from '@infra/router/module/community';
import mobileCommunity from '@infra/router/module/community.mobile.ts';
import mobileFeeInformation from '@infra/router/module/fee-information.mobile.ts';
import mobilePrivacyPolicy from '@infra/router/module/privacy-policy.mobile.ts';

const isMobile = /mobile/i.test(navigator.userAgent);

const getPlatformRoute = (
  mobileRoute: RouteRecordRaw,
  desktopRoute: RouteRecordRaw
) => (isMobile ? mobileRoute : desktopRoute);

const routes: RouteRecordRaw[] = [
  // {
  //   name: 'PaySmartro',
  //   path: '/smartro',
  //   component: () => import('@views/PaySmartro.vue'),
  //   meta: {
  //     // layout: 'ClearLayout',
  //   },
  // },
  {
    name: 'Test',
    path: '/test',
    component: () => import('@views/Test.vue'),
    meta: {},
  },
  {
    name: ROUTE_NAME.Main,
    path: '/',
    component: () => import('@views/Index.vue'),
    meta: {},
  },
  {
    name: ROUTE_NAME.RepairHomepage,
    path: '/repairs',
    component: () => import('@views/RepairHomepage.vue'),
    meta: {
      layout: 'ClearLayout',
    },
  },
  {
    name: ROUTE_NAME.NotFound,
    path: '/:pathMatch(.*)*',
    component: () => import('@views/NotFound.vue'),
    meta: {
      layout: 'ClearLayout',
      hasSectionTitle: false,
    },
  },
  {
    name: 'realNameReceivePopup',
    path: '/real-name-certificate/popup/:successFlag',
    component: () => import('@views/RealNameReceivePopup.vue'),
    props: true,
    meta: {
      layout: 'ClearLayout',
    },
  },
  {
    name: 'PayKS',
    path: '/ksnet',
    component: () => import('@views/PayKS.vue'),
    meta: {
      layout: 'ClearLayout',
    },
  },
  {
    name: 'PayKSResult',
    path: '/ksnet-result',
    component: () => import('@views/PayKSResult.vue'),
    meta: {
      layout: 'ClearLayout',
    },
  },
  {
    name: ROUTE_NAME.SignIn,
    path: '/sign-in',
    component: () => import('@views/main/SignIn.vue'),
    meta: {
      breadcrumbName: '로그인',
    },
  },
  {
    name: ROUTE_NAME.SignInAdmin,
    path: '/sign-in-admin',
    component: () => import('@views/main/SignInAdmin.vue'),
    meta: {
      breadcrumbName: '관리자 로그인',
    },
  },
  getPlatformRoute(mobileClubIntroduction, desktopClubIntroduction),
  getPlatformRoute(mobileUseInformation, desktopUseInformation),
  ...(isMobile ? [mobileFeeInformation] : []),
  ...(isMobile ? [mobilePrivacyPolicy] : []),
  courseIntroduction,
  facility,
  reservation,
  myPage,
  getPlatformRoute(mobileCommunity, desktopCommunity),
];

export default routes;
